module.exports = __webpack_public_path__ + "static/img/active5.72421c98.png";